export const statusTimelineStepLabelText = (theme) => {
  const { typography: labelType } = theme.palette.statusTimeline.stepLabel;
  return {
    fontWeight: labelType.fontWeight,
    fontSize: labelType.fontSize,
    lineHeight: labelType.lineHeight,
    paddingBottom: theme.spacing(labelType.paddingBottom),
  };
};

export const statusTimelineStepContentText = (theme) => {
  const { typography: contentType } = theme.palette.statusTimeline.stepContent;
  return {
    fontWeight: contentType.fontWeight,
    fontSize: contentType.fontSize,
    lineHeight: contentType.lineHeight,
  };
};

export const statusTimelineStepContentBase = (theme) => {
  const { stepContent, iconSize, stepLabel } = theme.palette.statusTimeline;
  const textInset = iconSize + parseFloat(theme.spacing(stepLabel.iconGap));
  return {
    marginLeft: 0,
    padding: 0,
    paddingLeft: textInset,
    minHeight: theme.spacing(stepContent.height),
    boxSizing: "border-box",
    borderLeft: "none",
    position: "relative",
    verticalAlign: "top",
    "& .MuiTypography-root": statusTimelineStepContentText(theme),
  };
};

export const statusTimelineStepLayout = (theme) => {
  const { stepInnerGap, stepGap } = theme.palette.statusTimeline;
  return {
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(stepInnerGap),
    marginBottom: theme.spacing(stepGap),
    padding: 0,
    "&:last-child": { marginBottom: 0 },
  };
};

export const statusTimelineConnectorLine = (theme, variant) => {
  const { connector, stepContent } = theme.palette.statusTimeline;
  const { dash, gap, width, gradientStart, gradientEnd } = connector;
  const start = connector[variant].start;
  const end = variant === "pending" ? theme.palette.accent.butterscotchBg : connector.success.end;
  const dashMask = `repeating-linear-gradient(to bottom, #000 0 ${dash}px, transparent ${dash}px ${dash + gap}px)`;
  return {
    ...statusTimelineStepContentBase(theme),
    "&::before": {
      content: '""',
      position: "absolute",
      left: theme.spacing(stepContent.lineOffset),
      top: 0,
      bottom: 0,
      width,
      background: `linear-gradient(to bottom, ${start} ${gradientStart}, ${end} ${gradientEnd})`,
      WebkitMask: dashMask,
      mask: dashMask,
    },
  };
};
